export default {
  en: {
    "label.warning": "Warning",
    "label.fill_required_fields": "Fill all required fields!",
    "label.anchor.profile": "Profile",
    "label.heading.logout": "Logout",
    "label.button.login": "Login",
  },
  fr: {
    "label.warning": "Attention",
    "label.fill_required_fields": "Remplissez tous les champs obligatoires !",
    "label.anchor.profile": "Profil",
    "label.heading.logout": "Déconnexion",
    "label.button.login": "Connexion",
  },
  es: {
    "label.warning": "¡Advertencia!",
    "label.fill_required_fields": "¡Complete todos los campos obligatorios!",
    "label.anchor.profile": "Perfil",
    "label.heading.logout": "Cerrar sesión",
    "label.button.login": "Iniciar sesión",
  },
  pt: {
    "label.warning": "Atenção",
    "label.fill_required_fields": "Preencha todos os campos obrigatórios!",
    "label.anchor.profile": "Perfil",
    "label.heading.logout": "Sair",
    "label.button.login": "Entrar",
  },
  zh_CN: {
    "label.warning": "警告",
    "label.fill_required_fields": "填写所有必填字段！",
    "label.anchor.profile": "个人资料",
    "label.heading.logout": "登出",
    "label.button.login": "登录",
  },
  hi: {
    "label.warning": "चेतावनी",
    "label.fill_required_fields": "सभी आवश्यक फ़ील्ड्स को भरें!",
    "label.anchor.profile": "प्रोफ़ाइल",
    "label.heading.logout": "लॉगआउट",
    "label.button.login": "लॉगिन",
  },
  ka: {
    "label.warning": "გაფრთხილება",
    "label.fill_required_fields": "შეავსეთ ყველა საჭირო ველი!",
    "label.anchor.profile": "ಪ್ರೊಫೈಲ್",
    "label.heading.logout": "ಲಾಗ್ ಔಟ್",
    "label.button.login": "ಲಾಗಿನ್",
  },
  lo: {
    "label.warning": "ແຈ້ງການ",
    "label.fill_required_fields": "ກະລຸນາຕື່ມລາຍລະອຽດທັງຫມົດ!",
    "label.anchor.profile": "ໂປຣໄຟລ໌",
    "label.heading.logout": "ອອກຈາກລະບົບ",
    "label.button.login": "ເຂົ້າລະບົບ",
  },
  my_MM: {
    "label.warning": "သတိပေးချက်",
    "label.fill_required_fields": "လိုအပ်သည့်လိပ်စာများအားပြည်သူအားဖြည့်ပေးပါ!",
    "label.anchor.profile": "ပရိုဖိုင်",
    "label.heading.logout": "ထွက်ပါ",
    "label.button.login": "လော့ဂ်အင်",
  },
  my: {
    "label.warning": "သတိပေးချက်",
    "label.fill_required_fields": "လိုအပ်သည့်လိပ်စာများအားပြည်သူအားဖြည့်ပေးပါ!",
    "label.anchor.profile": "ပရိုဖိုင်",
    "label.heading.logout": "ထွက်ပါ",
    "label.button.login": "လော့ဂ်အင်",
  },
  vi: {
    "label.warning": "Cảnh báo",
    "label.fill_required_fields": "Hãy điền đầy đủ các trường bắt buộc!",
    "label.anchor.profile": "Hồ sơ",
    "label.heading.logout": "Đăng xuất",
    "label.button.login": "Đăng nhập",
  },
};
